import * as React from "react";

export const IconChatSent = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" height="1em" width="1em" {...props}>
    <path fill="none" d="M0 0h24v24H0z"></path>
    <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"></path>
  </svg>
);
